import { render, staticRenderFns } from "./BrandProfile.vue?vue&type=template&id=37e5fa25&scoped=true"
import script from "./BrandProfile.vue?vue&type=script&lang=js"
export * from "./BrandProfile.vue?vue&type=script&lang=js"
import style0 from "./BrandProfile.vue?vue&type=style&index=0&id=37e5fa25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e5fa25",
  null
  
)

export default component.exports